import {Box, Grid, TextField, Typography} from "@mui/material";
import {Verified} from "@mui/icons-material";
import {useSelector} from "react-redux";

const BidItemBottomGrid = ({item}) => {
    const isForUAE = JSON.parse(process.env.REACT_APP_FOR_UAE)
    const minBoxWidth = 120
    const chartData = useSelector((state) => state.bidComparsionSlice.comparsionChartData)
    let maxSequence = null;
    for (const item of chartData?.approvalInformations) {
        const sequence = item.sequence;
        if (maxSequence === null || sequence > maxSequence) {
            maxSequence = sequence;
        }
    }
    let bidApprovals = [...chartData?.bids?.map(x => x?.bidApprovals)]
    bidApprovals = [].concat(...bidApprovals).filter(x => x?.bidMainId === item?.bidMainId && x?.sequence === maxSequence)
    const isWinner = bidApprovals?.some(x => x?.approveStatus == 1)
    return (
        <Grid container style={{borderRight: '1px solid #000'}}
              className={`bottom-grid ${item?.discualified && 'bg-grey'}`}
              sx={{borderRight: '1px solid rgba(224, 224,224,1)', width: '100%'}}>
            <Grid item sm={12} md={isWinner ? 5.5 : 6}>
                <Box display="flex" sx={{px: 2, pt: 1}} alignItems="center" gap={1}>
                    <Typography sx={{minWidth: minBoxWidth, fontSize: '14px'}}>Delivery Terms</Typography>
                    <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                               value={item?.deliveryTerms}
                               size="small" disabled/>
                </Box>
                <Box display="flex" sx={{px: 2, pt: 0.5}} alignItems="center" gap={1}>
                    <Typography sx={{minWidth: minBoxWidth, fontSize: '14px'}}>Delivery Time</Typography>
                    <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                               value={item?.deliveryTime}
                               size="small" disabled/>
                </Box>
                <Box display="flex" sx={{px: 2, pt: 0.5}} alignItems="center" gap={1}>
                    <Typography sx={{minWidth: minBoxWidth, fontSize: '14px'}}>Payment Terms</Typography>
                    <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                               value={item?.paymentTerms}
                               size="small" disabled/>
                </Box>
                <Box display="flex" sx={{px: 2, pt: 0.5}} alignItems="center" gap={1}>
                    <Typography sx={{minWidth: minBoxWidth, fontSize: '14px'}}>Expected Cost</Typography>
                    <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                               value={item?.expectedCost}
                               size="small" disabled/>
                </Box>
                <Box display="flex" sx={{px: 2, pt: 0.5}} alignItems="center" gap={1}>
                    <Typography sx={{minWidth: minBoxWidth, fontSize: '14px'}}>Budget Balance</Typography>
                    <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                               value={item?.budgetBalance}
                               size="small" disabled/>
                </Box>
                {isForUAE && (
                    <Box display="flex" sx={{px: 2, pt: 0.5, pb: 1}} alignItems="center" gap={1}>
                        <Typography sx={{minWidth: minBoxWidth, fontSize: '14px'}}>Converted Gross</Typography>
                        <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                                   value={item?.convertedGross}
                                   size="small" disabled/>
                    </Box>
                )}
            </Grid>
            <Grid item sm={12} md={isWinner ? 5.5 : 6}>
                <Box display="flex" sx={{px: 2, pt: 1}} alignItems="center" gap={1}>
                    <Typography
                        sx={{minWidth: minBoxWidth, fontSize: '14px'}}>{item?.currencyCode}</Typography>
                    <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                               value={item?.total}
                               size="small" disabled/>
                </Box>
                <Box display="flex" sx={{px: 2, pt: 0.5}} alignItems="center" gap={1}>
                    <Typography sx={{minWidth: minBoxWidth, fontSize: '14px'}}>Discount</Typography>
                    <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                               value={item?.discount}
                               size="small" disabled/>
                </Box>
                <Box display="flex" sx={{px: 2, pt: 0.5}} alignItems="center" gap={1}>
                    <Typography sx={{minWidth: minBoxWidth, fontSize: '14px'}}>% Amount</Typography>
                    <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                               value={item?.discountedAmount}
                               size="small" disabled/>
                </Box>
                <Box display="flex" sx={{px: 2, pt: 0.5}} alignItems="center" gap={1}>
                    <Typography fontWeight="bold" sx={{minWidth: minBoxWidth, fontSize: '14px'}}>Base</Typography>
                    <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                               value={item?.baseAmount}
                               size="small" disabled/>
                </Box>
                <Box display="flex" sx={{px: 2, pt: 0.5}} alignItems="center" gap={1}>
                    <Typography fontWeight="bold" sx={{minWidth: minBoxWidth, fontSize: '14px'}}>Reporting</Typography>
                    <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                               value={item?.reportingAmount}
                               size="small" disabled/>
                </Box>
                {isForUAE && (
                    <Box display="flex" sx={{px: 2, pt: 0.5, pb: 1}} alignItems="center" gap={1}>
                        <Typography sx={{minWidth: minBoxWidth, fontSize: '14px'}}>Total With Rate</Typography>
                        <TextField InputProps={{style: {background: '#e8e8e8', fontSize: '1rem', height: '26px'}}}
                                   value={item?.baseTotalWithRate}
                                   size="small" disabled/>
                    </Box>
                )}
            </Grid>
            {isWinner &&
                <Grid item sm={12} md={1}>
                    <Verified className="bid-comparison-chart-verified"/>
                </Grid>}
        </Grid>
    )
}

export default BidItemBottomGrid
